import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import { Button } from './ui/button';

const ExportToolbar = () => {
  const location = useLocation();
  const [isExportMenuOpen, setIsExportMenuOpen] = useState(false);
  const exportMenuRef = useRef(null);

  const getExportOptions = () => {
    const pathname = location?.pathname;

    if (pathname === '/health-system-overview') {
      return [
        { label: 'Export WHO Report', icon: 'FileText', action: 'who-report' },
        { label: 'Export to PDF', icon: 'FileDown', action: 'pdf' },
        { label: 'Export to Excel', icon: 'FileSpreadsheet', action: 'excel' },
        { label: 'Print Dashboard', icon: 'Printer', action: 'print' }
      ];
    }

    if (pathname === '/program-performance') {
      return [
        { label: 'Export Program Review', icon: 'FileText', action: 'program-review' },
        { label: 'Export to PDF', icon: 'FileDown', action: 'pdf' },
        { label: 'Export to Excel', icon: 'FileSpreadsheet', action: 'excel' },
        { label: 'Share Report', icon: 'Share2', action: 'share' }
      ];
    }

    if (pathname === '/facility-operations') {
      return [
        { label: 'Export Operations Report', icon: 'FileText', action: 'operations-report' },
        { label: 'Export to PDF', icon: 'FileDown', action: 'pdf' },
        { label: 'Export to Excel', icon: 'FileSpreadsheet', action: 'excel' },
        { label: 'Print Report', icon: 'Printer', action: 'print' }
      ];
    }

    return [];
  };

  const exportOptions = getExportOptions();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exportMenuRef?.current && !exportMenuRef?.current?.contains(event?.target)) {
        setIsExportMenuOpen(false);
      }
    };

    if (isExportMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExportMenuOpen]);

  const handleExportAction = (action) => {
    console.log(`Export action: ${action}`);
    setIsExportMenuOpen(false);
  };

  const handleRefresh = () => {
    console.log('Refreshing data...');
  };

  if (exportOptions?.length === 0) {
    return null;
  }

  return (
    <div className="export-toolbar">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={handleRefresh}
        >
          <Icon name="RefreshCw" size={16} className="mr-2" />
          Refresh Data
        </Button>
      </div>
      <div className="export-actions relative" ref={exportMenuRef}>
        <Button
          variant="default"
          size="sm"
          onClick={() => setIsExportMenuOpen(!isExportMenuOpen)}
        >
          <Icon name="Download" size={16} className="mr-2" />
          Export
        </Button>

        <div className={`dropdown-menu ${isExportMenuOpen ? 'open' : ''}`}>
          {exportOptions?.map((option) => (
            <div
              key={option?.action}
              className="dropdown-item"
              onClick={() => handleExportAction(option?.action)}
            >
              <Icon name={option?.icon} size={16} className="inline-block mr-2" />
              {option?.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExportToolbar;